import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';
import { Star, Quote } from 'lucide-react';

const references = [
  {
    id: 1,
    name: 'Mgr. Martina M.',
    role: 'Ředitelka mateřské školy',
    school: 'MŠ v Praze',
    text: 'Děkujeme za zaslané materiály. Současně bych chtěla poděkovat za výběr skvělého lektora, který nás školil. Lektor měl profesionální a přátelský přístup, byl velmi trpělivý a s humorem se pokoušel naučit nás smysluplně využívat moderní nástroje umělé inteligence. Těšíme se na další školení a kurzy.',
    rating: 5
  },
  {
    id: 2,
    name: 'Daniela G.',
    role: 'Učitelka MŠ',
    school: 'MŠ Valašská Polanka',
    text: 'Kurz byl skvělý, paní lektorka úžasná, komunikace se zástupci vzdělávací agentury zcela bezproblémová a přátelská.',
    rating: 5
  },
  {
    id: 3,
    name: 'Karolína V.',
    role: 'Učitelka MŠ',
    school: 'MŠ ve středočeském kraji',
    text: 'Jsem nesmírně vděčná, že jsem do kurzu šla. Vedl ho příjemný, vždy nápomocný a klidný lektor. Předal nám spoustu cenných rad a skvělé bylo i vzájemné sdílení pedagogických zkušeností. Do doby než jsem začala navštěvovat kurz jsem věděla jen o nástroji ChatGPT... Díky prohloubení znalostí mohu efektivněji psát různá hodnocení, tvořit TVP, plánovat. A asi největší radost je, že jsem se naučila s Canvou - tvoření materiálů do školky je pro mě nyní radost.',
    rating: 5
  },
  {
    id: 4,
    name: 'Pedagog ZŠ',
    role: 'Učitel základní školy',
    school: 'ZŠ v Praze',
    text: 'Chtěla bych Vám poděkovat za školení. Můj dojem je velmi pozitivní – dokázal jste udržet naši pozornost celých 16 hodin, což se jen tak někomu nepodaří, v této formě online výuky. Váš výklad byl jasný, k věci, a díky různým vychytávkám a praktickým postřehům byla výuka zajímavá a inspirativní. Školení pro mne bylo velkým přínosem, i když už jsem s GPT a Canvou měla zkušenost – i tak jsem se naučila nové věci a dostala inspiraci, jak je lépe využívat v praxi.',
    rating: 5
  },
  {
    id: 5,
    name: 'Učitelka ZŠ',
    role: 'Pedagog',
    school: 'Základní škola',
    text: 'Děkuji Vám za vstřícnost a srozumitelný výklad i pro méně PC zdatné. Líbí se mi přizpůsobení se všem a zároveň zvládnutí lekce.',
    rating: 5
  },
  {
    id: 6,
    name: 'Iva G.',
    role: 'Pedagog',
    school: 'Střední škola',
    text: 'Moc Vám děkuji za velmi laskavý a klidný přístup, byl jste velmi trpělivý. Rozhodně jste to neměl jednoduché, když každá z účastnic měla úplně jinou úroveň znalostí v této oblasti. Pro mě bylo vše nové a AI nástroje jsou prostě zázrak, který určitě využiji. Bylo super, že jste klasickou výuku prohloubil i o možnosti využití AI nejen pro pracovní věci, ale i to co využijeme v osobním životě.',
    rating: 5
  },
  {
    id: 7,
    name: 'Iva G.',
    role: 'Odborný pracovník',
    school: '',
    text: 'Školení velmi příjemné, přínosné a hlavně skvěle vedené! Určitě doporučuji!',
    rating: 5,
    source: 'Google recenze'
  },
  {
    id: 8,
    name: 'SM-DATA',
    role: 'Firma',
    school: '',
    text: 'Děkujeme Vám za hodnotně strávený čas, který nebyl jen „suchou" přednáškou ale poskytl dostatečný prostor i pro hodnotnou diskusi, kudy se má správně AI ubírat v našem oboru, která myslím, že byla vzájemně obohacující.',
    rating: 5,
    source: 'Google recenze'
  },
  {
    id: 9,
    name: 'Juraj L.',
    role: 'Odborník na automatizaci',
    school: '',
    text: 'Skvelý a prínosný kurz k automatizácii procesov s AI - chválim lektora, ktorý na mieste vyriešil konkrétny proces, ktorý som potreboval zautomatizovať.',
    rating: 5,
    source: 'Google recenze'
  },
  {
    id: 10,
    name: 'Blanka L.',
    role: 'Účastník kurzu',
    school: '',
    text: 'Skvělí lektoři, školení v oblasti AI, odborné znalosti a opravdu rozsáhlý přehled v různých oblastech využití.',
    rating: 5,
    source: 'Google recenze'
  }
];

export default function ReferencesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-white to-cyan-50/30" />
          <div className="absolute top-1/3 right-0 w-[400px] h-[400px] bg-teal-100/30 rounded-full blur-3xl" />
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-6">
                <Star className="w-4 h-4 fill-teal-600" />
                <span>Více než 1 500 spokojených pedagogů</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                Co o nás říkají naši klienti
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed">
                Zpětná vazba od pedagogů a škol, které prošly našimi kurzy AI
              </p>
            </div>
          </div>
        </section>

        {/* References Grid */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-6">
              {references.map((reference) => (
                <div 
                  key={reference.id}
                  className="bg-white rounded-xl p-8 shadow-sm border border-slate-100 hover:shadow-md hover:border-teal-100 transition-all"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center flex-shrink-0">
                      <Quote className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-1 mb-2">
                        {[...Array(reference.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                        ))}
                      </div>
                      <h3 className="font-bold text-slate-900">{reference.name}</h3>
                      <p className="text-sm text-slate-600">{reference.role}</p>
                      {reference.school && (
                        <p className="text-sm text-teal-600">{reference.school}</p>
                      )}
                      {reference.source && (
                        <p className="text-xs text-slate-500 italic mt-1">{reference.source}</p>
                      )}
                    </div>
                  </div>
                  
                  <p className="text-slate-700 leading-relaxed">
                    "{reference.text}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}
